import React, { RefObject } from 'react'
import SectionWithTag, { Side } from '../../../components/SectionWithTag'
import Image from '../../../components/Image'
import { twMerge } from 'tailwind-merge'
import { FormattedMessage } from 'react-intl'
import ScrollLink from '../../../components/ScrollLinkAlt'

const id = 'page.epp.performance'

interface PerformanceProps {
  scrollRef: RefObject<HTMLDivElement>
}

const Performance = ({ scrollRef }: PerformanceProps) => {
    return (
        <div className=''>
            <div className={twMerge('py-12 md:pt-30 md:pb-20 bg-white 3xl:max-w-screen-2xl mx-auto')}>
                <SectionWithTag tag={{ id: `${id}.tag` }} side={Side.LEFT}>
                    <div className='pt-9 pr-6 md:pr-14 md:pt-0'>
                        <div className='lg:pt-0 flex flex-col lg:flex-row lg:justify-between 2xl:justify-start gap-y-12 lg:gap-x-20 2xl:gap-x-[180px] 3xl:justify-between'>
                            <div className='order-2 flex items-center'>
                                <div className='lg:max-w-[650px] 2xl:max-w-[800px] 3xl:max-w-[700px]'>
                                    <FormattedMessage id={`${id}.text`} tagName='h5' />
                                    <div className='pt-4 md:pt-8 lg:pt-10'>
                                        <ScrollLink title={`${id}.cta.button`} scrollRef={scrollRef} />
                                    </div>
                                </div>
                            </div>
                            <div className='order-1 lg:order-last lg:mr-10'>
                                <div className='max-w-[420px] mx-auto'>
                                    <Image
                                        draggable={false}
                                        className='object-cover w-full h-full'
                                        alt='performance'
                                        slug='performance-desktop'
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </SectionWithTag>
            </div>
        </div>
    )
}

export default Performance
